import {useEffect} from 'react';
import {useInView} from 'react-intersection-observer';
import {aggregateAndSendLog} from '../../../../logging/aggregateAndSendLog';
import {putTiaraObjectProps} from '../../../../logging/putTiaraObjectProps';
import {CommonSectionProps} from '../../type';

export function PromotionBanner({section, children}: CommonSectionProps) {
  const {ref, inView, entry} = useInView();

  useEffect(() => {
    if (inView && entry?.target) {
      aggregateAndSendLog({
        targetElem: entry.target as HTMLElement,
        actionType: 'ViewImp',
        actionName: '섹션_노출',
        customProps: {
          user_action: 'imp',
        },
        viewimp_contents: {
          imp_provider: 'service',
          imp_type: 'vimp',
        },
      });
    }
  }, [entry, inView]);

  return (
    <div
      ref={ref}
      {...putTiaraObjectProps({
        click: {
          layer1: '프로모션',
          imp_id: 'spromo_b_001',
          imp_provider: 'service',
        },
        viewimp_contents: {
          imp_id: 'spromo',
          layer1: '프로모션',
        },
        customProps: {
          section_type: '프로모션',
        },
      })}
    >
      <div>{children}</div>
    </div>
  );
}
